// extracted by mini-css-extract-plugin
export default {"deleteIcon":"src-components-Buttons-DeleteButton-css__deleteIcon--QrLJD","disable":"src-components-Buttons-DeleteButton-css__disable--JrWYn"};